import { render, staticRenderFns } from "./DeleteTypeStage.vue?vue&type=template&id=e51fdb18&"
import script from "./DeleteTypeStage.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports